"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addEvent = addEvent;
exports.sendQueuedEvents = sendQueuedEvents;
exports["default"] = exports.SEND_QUEUED_EVENTS_URL = exports.ADD_EVENT_URL = exports.LOCAL_STORAGE_KEY = void 0;

var _apiHelper = _interopRequireDefault(require("./api-helper.js"));
/**
 * js-utils-apm
 *
 * Copyright © 2016 Appfolio, Inc. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */
// Report events by calling
//
// Example Usage:
//
//   // Add an event to PropertyNewRelicInsights
//   addEvent('eventName');
//
//   // Specify some data with the event
//   addEvent('eventName', {
//     data: { count: 3, doingStuff: true, petName: 'Spot' }
//   });
//
//   // Include the current user's login and information about the current
//   // controller and action
//   addEvent('eventName', {
//     options: { includeLogin: true, includeControllerAndAction: true }
//   });
//
//   // All together now!
//
//   addEvent('eventName', {
//     data: { count: 3, doingStuff: true, petName: 'Spot' },
//     options: { includeLogin: true, includeControllerAndAction: true }
//   });
//
//   See app/controllers/property_new_relic_insights/events_controller in apm_bundle for more
//   information about options.
//


var LOCAL_STORAGE_KEY = 'new_relic_insights_events';
exports.LOCAL_STORAGE_KEY = LOCAL_STORAGE_KEY;
var ADD_EVENT_URL = '/property_new_relic_insights/events';
exports.ADD_EVENT_URL = ADD_EVENT_URL;
var SEND_QUEUED_EVENTS_URL = '/property_new_relic_insights/events/bulk_create';
exports.SEND_QUEUED_EVENTS_URL = SEND_QUEUED_EVENTS_URL;

function pathName(includeControllerAndAction, win) {
  return includeControllerAndAction ? win.location.pathname : '';
}

function includeLogin(i) {
  return !!i;
}

function getQueuedEvents(win) {
  var queuedEvents = win.sessionStorage.getItem(LOCAL_STORAGE_KEY);

  if (queuedEvents === null) {
    queuedEvents = [];
  } else {
    queuedEvents = JSON.parse(queuedEvents);
  }

  return queuedEvents;
}

function enqueueEvent(event, win) {
  var currentQueueContents = getQueuedEvents(win);
  currentQueueContents.push(event);
  return win.sessionStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(currentQueueContents));
} // `type`
//   The label for the event in PropertyNewRelicInsights. Should be camelCase.
//
// `params`
//   An object with optional members `data` and `options`.
//
// `params.data`
//   An object of arbitrary key/value pairs to report to NewRelic. NewRelic
//   only supports strings and floats. Integers and booleans will be coerced
//   for you, though. Keys should be snake_case.
//
// `params.options`
//   An object of key/value pairs corresponding to the options available in
//   the PropertyNewRelicInsights::EventsController. Examine $.post below and
//   app/controllers/property_new_relic_insights/events_controller.rb for more
//   information.
//


function addEvent(type, params) {
  var win = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : window;
  var data = params.data || {};
  var options = params.options || {};
  var result;

  if (options.sendLater) {
    result = enqueueEvent({
      type: type,
      data: data,
      options: options
    }, win);
  } else {
    result = _apiHelper["default"].post(ADD_EVENT_URL, {
      type: type,
      data: JSON.stringify(data),
      include_login: includeLogin(options.includeLogin),
      path_name: pathName(options.includeControllerAndAction, win)
    });
  }

  return result;
}

function sendQueuedEvents() {
  var win = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window;
  var queuedEvents = getQueuedEvents(win);

  if (queuedEvents.length === 0) {
    return undefined;
  }

  win.sessionStorage.removeItem(LOCAL_STORAGE_KEY);
  var eventsForPost = [];
  queuedEvents.forEach(function (queuedEvent) {
    return eventsForPost.push({
      type: queuedEvent.type,
      data: JSON.stringify(queuedEvent.data),
      include_login: includeLogin(queuedEvent.options.includeLogin),
      path_name: pathName(queuedEvent.options.includeControllerAndAction, win)
    });
  });
  return _apiHelper["default"].post(SEND_QUEUED_EVENTS_URL, {
    events_json: JSON.stringify(eventsForPost)
  });
}

var _default = {
  addEvent: addEvent,
  sendQueuedEvents: sendQueuedEvents,
  ADD_EVENT_URL: ADD_EVENT_URL,
  SEND_QUEUED_EVENTS_URL: SEND_QUEUED_EVENTS_URL,
  LOCAL_STORAGE_KEY: LOCAL_STORAGE_KEY
};
exports["default"] = _default;